module.exports = __webpack_public_path__ + "static/media/slide3_article2.cb6c82ce.jpg";